import { useState } from '@max/max';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { request as maxRequest } from '@max/meituan-uni-network';
import { getAppVersion, PlatformType, getPlatformType, getSystemType, SystemType } from '@nibfe/mkt-env-api';
import { INVALID_CODES } from '@/types/shared';
import { useLoading } from './useLoading';
import { getRiskParams } from '@nibfe/mkt-risk-api';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://ihotel.meituan.com',
    TEST: 'https://wangshiyang05-jlkah-sl-api.hotel.test.meituan.com',
    PAPI_MOCK: 'https://papi.sankuai.com/api/req/c80c3278-f278-493d-b8c1-4f8048562846'
};
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
})(RequestStatus || (RequestStatus = {}));
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    // 美团APP
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    // 点评APP
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    // 微信美团小程序
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    // 微信酒店+小程序
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI"; // 微信点评小程序
})(Source || (Source = {}));
export function useRequest(path, options) {
    const { raw = false, showLoading = false, loadingText, method = 'POST' } = options || {};
    const ctx = useMonitorEngineContext();
    const { openLoading, closeLoading } = useLoading();
    const [requestStatus, setRequestStatus] = useState(RequestStatus.SUCCESS);
    const request = async (params) => {
        try {
            const { uuid, platform, userId, token, lat, lng } = ctx._runtimeInfo.commonParams;
            setRequestStatus(RequestStatus.LOADING);
            if (showLoading) {
                openLoading(loadingText);
            }
            // const isPtest = false; //TODO:important
            let finalRequestParams = params;
            if (true) {
                try {
                    const antiReq = new AntiReqTool({
                        autoFillParams: true
                    });
                    // @ts-ignore
                    finalRequestParams = antiReq.addCommonParams(finalRequestParams);
                }
                catch {
                    ctx._raptorReport.monitorReportLog('请求加上反爬参数错误', '请求加上反爬参数错误', {
                        level: 'warn',
                        category: 'jsError'
                    });
                }
            }
            let url = `${API_MAP.PROD}${path}`;
            // let url = `${API_MAP.TEST}${path}`;//TODO:important
            // if (isPtest) {
            //   finalRequestParams.isPtest = 'true';
            //   url = `${url}?isPtest=true`;
            // }
            let riskParams = {};
            try {
                riskParams = await getRiskParams(/** 风险标识-酒店 */ 2);
            }
            catch (e) {
                // empty
            }
            const version = getAppVersion();
            const riskRequest = {
                ...riskParams,
                uuid,
                version,
                expoId: ctx._runtimeInfo.queryParams.expoId || '',
                latitude: Number.isNaN(Number(lat)) ? 0 : Number(lat),
                longitude: Number.isNaN(Number(lng)) ? 0 : Number(lng)
            };
            const response = await new Promise((resolve, reject) => {
                maxRequest({
                    url,
                    data: {
                        ...finalRequestParams,
                        riskRequest,
                        userId: Number(userId),
                        token,
                        platform: platform === 'dp' ? 2 : 1,
                        source: getSource(),
                        pageSource: ctx._runtimeInfo.queryParams.pageSource || '',
                        cityId: Number(ctx._runtimeInfo.cityId) || 0,
                        locateCityId: Number(ctx._runtimeInfo.cityId) || 0,
                        latitude: Number.isNaN(Number(lat)) ? 0 : Number(lat),
                        longitude: Number.isNaN(Number(lng)) ? 0 : Number(lng),
                        uuid,
                        version
                    },
                    method,
                    header: {
                        'content-type': 'application/json',
                        token: token || ''
                    },
                    _meituan: {
                        requestType: 'MRNUtils',
                        mrnChannel: 'hotel'
                        // params: finalRequestParams, // TODO:important
                    },
                    success(res) {
                        ctx._raptorReport.monitorReportNetworkSuccess?.({
                            apiPath: path
                        });
                        if (raw) {
                            resolve(res);
                            return;
                        }
                        if (res?.data?.status === 0) {
                            const templateRes = res?.data?.data;
                            resolve(templateRes);
                        }
                        else if (INVALID_CODES.includes(res?.data?.status)) {
                            resolve({
                                uni_status_code: res?.data?.status
                            });
                        }
                        else {
                            const error = new Error(AJAX_ERROR_NAME);
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-code非0';
                            let tags = {};
                            try {
                                tags = {
                                    response: JSON.stringify(res),
                                    params: JSON.stringify(finalRequestParams)
                                };
                            }
                            catch (e) { }
                            ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                                level: 'info',
                                category: 'ajaxError',
                                tags
                            });
                            reject(error);
                        }
                    },
                    fail(error) {
                        ctx._raptorReport.monitorReportNetworkFailed?.({
                            apiPath: path
                        });
                        if (typeof error === 'object') {
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-网络异常';
                        }
                        let tags = {};
                        try {
                            tags = {
                                errorInfo: JSON.stringify(error),
                                params: JSON.stringify(finalRequestParams),
                                apiPath: path
                            };
                        }
                        catch (e) { }
                        ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                            level: 'info',
                            category: 'ajaxError',
                            tags
                        });
                        reject(error);
                    }
                });
            });
            if (showLoading) {
                closeLoading();
            }
            setRequestStatus(RequestStatus.SUCCESS);
            return response;
        }
        catch (err) {
            if (showLoading) {
                closeLoading();
            }
            setRequestStatus(RequestStatus.ERROR);
            if (err instanceof Error && err.name !== AJAX_ERROR_NAME) {
                let tags = {};
                try {
                    tags = {
                        errorInfo: JSON.stringify(err),
                        params: JSON.stringify(params)
                    };
                }
                catch (e) { }
                ctx._raptorReport.monitorReportLog?.(err.message, err, {
                    level: 'error',
                    category: 'jsError',
                    tags
                });
            }
            return null;
        }
    };
    return {
        requestStatus,
        request
    };
}
export function getSource() {
    const platformType = getPlatformType();
    switch (platformType) {
        case PlatformType.mtApp:
        case PlatformType.mtAppWebView:
            return Source.MEITUAN_APP;
        case PlatformType.dpApp:
        case PlatformType.dpAppWebView:
            return Source.DIANPING_APP;
        case PlatformType.mtMinaWebview:
            return Source.WECHAT_MEITUAN_MINI;
        case PlatformType.mtHotelMinaWebview:
            return Source.WECHAT_HOTEL_MINI;
        case PlatformType.dpMinaWebview:
            return Source.WECHAT_DIANPING_MINI;
        default:
            return Source.MEITUAN_APP;
    }
}
export const IS_IOS = getSystemType() === SystemType.ios;
export const IS_ANDROID = getSystemType() === SystemType.android;
export const IS_HARMONY = getSystemType() === SystemType.harmony;
